<!-- ── Toolbar: search + filter + download (left) + add + bulk-delete ──────── -->
<div class="list-ignore-codes__toolbar">
  <ui-form-field
    [formControl]="searchControl"
    [prefixIcon]="'search'"
    [placeholder]="'knowledge_base.ignore_codes.search_placeholder' | translate"
    class="list-ignore-codes__search"
  >
  </ui-form-field>
  <div class="filter-button-group">
    <button class="action-button" (click)="setFilter()" [ngClass]="{ activeFilter: hasActiveFilters() }">
      <div class="action-button-icon">
        <img src="assets/icones/filter_icon.svg" alt="" />
      </div>
      <span class="action-button-text">{{ "knowledge_base.filter" | translate }}</span>
      <div class="clear-icon-container">
        <img
          class="clear-icon"
          *ngIf="hasActiveFilters()"
          (click)="clearFilter(); $event.stopPropagation()"
          src="assets/icones/clear-icon.svg"
          alt=""
        />
        <div class="clear-tooltip" *ngIf="hasActiveFilters()">
          {{ "common.clear_filters" | translate }}
        </div>
      </div>
    </button>
  </div>
  <ui-button [label]="'knowledge_base.download' | translate" type="secondary" icon="download_icon" (click)="exportList()"> </ui-button>
  <div class="list-ignore-codes__toolbar-actions">
    <!-- Bulk actions for the current selection live in the floating
         ui-bulk-actions-bar at the bottom of the table, not here. -->
    <ui-button
      *appHasPermission="{ module: 'knowledge_base', action: 'create' }"
      type="primary-text-outlined"
      icon="plus-cc"
      iconSize="large"
      [label]="'knowledge_base.ignore_codes.add_ignore_code' | translate"
      (click)="openCreateModal()"
    >
    </ui-button>
  </div>
</div>

<!-- ── Table ─────────────────────────────────────────────────────────────── -->
<div class="list-ignore-codes__table" [class.list-ignore-codes__table--with-bulk-bar]="selection.hasSelection">
  <!-- Header -->
  <div class="list-ignore-codes__table-header">
    <div class="list-ignore-codes__table-cell list-ignore-codes__table-cell--checkbox" (click)="$event.stopPropagation()">
      <ui-checkbox
        [checked]="selection.isAllSelected"
        [indeterminate]="selection.isPartialSelected"
        [ariaLabel]="'common.select_all' | translate"
        (changed)="selection.toggleAll($event.checked)"
      ></ui-checkbox>
    </div>
    <div class="list-ignore-codes__table-cell list-ignore-codes__table-cell--sortable" (click)="onSort('code')">
      {{ "knowledge_base.ignore_codes.col.code" | translate }}
      <div class="list-ignore-codes__table-cell-sort-actions">
        <span class="arrow-up" [class.active]="sortField === 'code' && sortMode === 'asc'"></span>
        <span class="arrow-down" [class.active]="sortField === 'code' && sortMode === 'desc'"></span>
      </div>
    </div>
    <div class="list-ignore-codes__table-cell list-ignore-codes__table-cell--sortable" (click)="onSort('extracted_name')">
      {{ "knowledge_base.ignore_codes.col.extracted_name" | translate }}
      <div class="list-ignore-codes__table-cell-sort-actions">
        <span class="arrow-up" [class.active]="sortField === 'extracted_name' && sortMode === 'asc'"></span>
        <span class="arrow-down" [class.active]="sortField === 'extracted_name' && sortMode === 'desc'"></span>
      </div>
    </div>
    <div class="list-ignore-codes__table-cell list-ignore-codes__table-cell--sortable" (click)="onSort('customer_name')">
      {{ "knowledge_base.ignore_codes.col.customer" | translate }}
      <div class="list-ignore-codes__table-cell-sort-actions">
        <span class="arrow-up" [class.active]="sortField === 'customer_name' && sortMode === 'asc'"></span>
        <span class="arrow-down" [class.active]="sortField === 'customer_name' && sortMode === 'desc'"></span>
      </div>
    </div>
    <div class="list-ignore-codes__table-cell list-ignore-codes__table-cell--sortable" (click)="onSort('source')">
      {{ "knowledge_base.ignore_codes.col.source" | translate }}
      <div class="list-ignore-codes__table-cell-sort-actions">
        <span class="arrow-up" [class.active]="sortField === 'source' && sortMode === 'asc'"></span>
        <span class="arrow-down" [class.active]="sortField === 'source' && sortMode === 'desc'"></span>
      </div>
    </div>
    <div class="list-ignore-codes__table-cell list-ignore-codes__table-cell--sortable" (click)="onSort('create_date')">
      {{ "knowledge_base.ignore_codes.col.created_date" | translate }}
      <div class="list-ignore-codes__table-cell-sort-actions">
        <span class="arrow-up" [class.active]="sortField === 'create_date' && sortMode === 'asc'"></span>
        <span class="arrow-down" [class.active]="sortField === 'create_date' && sortMode === 'desc'"></span>
      </div>
    </div>
  </div>

  <!-- Scrollable body -->
  <div class="list-ignore-codes__table-body">
    <!-- Loading state -->
    <div class="list-ignore-codes__loading" *ngIf="loading$ | async">
      <div class="list-ignore-codes__loading-spinner"></div>
    </div>

    <!-- Rows -->
    <ng-container *ngIf="!(loading$ | async) && sortedIgnoreCodes.length > 0">
      <div
        *ngFor="let item of sortedIgnoreCodes"
        class="list-ignore-codes__table-row"
        [class.is-not-editable]="!canEdit(item)"
        [matTooltip]="canEdit(item) ? '' : ('knowledge_base.ignore_codes.actions.edit_tooltip_disabled' | translate)"
        matTooltipPosition="above"
        (click)="openEditModal(item)"
      >
        <div class="list-ignore-codes__table-cell list-ignore-codes__table-cell--checkbox" (click)="$event.stopPropagation()">
          <ui-checkbox
            [checked]="selection.isSelected(item.id)"
            [ariaLabel]="'common.select' | translate"
            (changed)="selection.toggleOne(item.id, $event.checked, $event)"
          ></ui-checkbox>
        </div>
        <div class="list-ignore-codes__table-cell">{{ item.code }}</div>
        <div class="list-ignore-codes__table-cell">{{ item.extracted_name || "--" }}</div>
        <div class="list-ignore-codes__table-cell">{{ item.customer_name || "--" }}</div>
        <div class="list-ignore-codes__table-cell">
          <ng-container *ngIf="item.source === 'manual'">
            <span class="list-ignore-codes__source-badge list-ignore-codes__source-badge--manual">
              {{ "knowledge_base.ignore_codes.source.manual" | translate }}
            </span>
          </ng-container>
          <ng-container *ngIf="item.source === 'order_correction'">
            <a
              *ngIf="item.source_order_id"
              class="list-ignore-codes__order-link"
              [routerLink]="['/quotations', item.source_order_id]"
              (click)="$event.stopPropagation()"
            >
              {{ item.source_order_ref || ("knowledge_base.ignore_codes.source.order" | translate) }}
            </a>
            <span *ngIf="!item.source_order_id" class="list-ignore-codes__source-badge list-ignore-codes__source-badge--order">
              {{ "knowledge_base.ignore_codes.source.order" | translate }}
            </span>
          </ng-container>
        </div>
        <div class="list-ignore-codes__table-cell">{{ item.create_date ? (item.create_date | date: "dd/MM/yyyy") : "--" }}</div>
      </div>
    </ng-container>

    <!-- Empty state -->
    <div *ngIf="sortedIgnoreCodes.length === 0 && !(loading$ | async)" class="list-ignore-codes__empty">
      <ng-container *ngIf="!keyword && !hasActiveFilters()">
        <img class="list-ignore-codes__empty-illustration" src="assets/icones/no-result-search.svg" alt="" />
        <h3>{{ "knowledge_base.ignore_codes.empty_state" | translate }}</h3>
      </ng-container>
      <ng-container *ngIf="keyword || hasActiveFilters()">
        <img class="list-ignore-codes__empty-illustration" src="assets/icones/no-result-search.svg" alt="" />
        <h3>{{ "knowledge_base.ignore_codes.empty_state_search" | translate }}</h3>
      </ng-container>
    </div>
  </div>

  <!-- ───────────────────────────────────────────────────────────────────── -->
  <!-- Bulk actions for the current selection. Floats centred at the bottom of -->
  <!-- the table so selecting rows never reflows the toolbar above it.         -->
  <!-- ───────────────────────────────────────────────────────────────────── -->
  <ui-bulk-actions-bar
    *ngIf="selection.hasSelection"
    [count]="selection.count"
    (cleared)="selection.clear()"
  >
    <button
      *appHasPermission="{ module: 'knowledge_base', action: 'delete' }"
      class="ui-bulk-action ui-bulk-action--danger"
      (click)="bulkDelete()"
    >
      <ui-icon name="Trash2" size="medium"></ui-icon>
      <span>{{ 'common.delete' | translate }}</span>
    </button>
  </ui-bulk-actions-bar>
  <!-- ── END BULK ACTIONS BAR ─────────────────────────────────────────────── -->

  <!-- Pagination lives inside the bordered container, below the rows -->
  <app-pagination
    *ngIf="sortedIgnoreCodes.length > 0"
    class="list-ignore-codes__pagination"
    [pagination]="metadata$ | async"
    (toPageEvent)="toPage($event)"
  ></app-pagination>
</div>
